/**
 * @generated SignedSource<<755f48d3535920aeb17681a1cc7969d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavHeader_links$data = {
  readonly navItems: ReadonlyArray<{
    readonly hideSideNavTitle: boolean | null;
    readonly href: string | null;
    readonly items?: ReadonlyArray<{
      readonly hideSideNavTitle: boolean | null;
      readonly href: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly title: string | null;
  } | null> | null;
  readonly " $fragmentType": "NavHeader_links";
};
export type NavHeader_links$key = {
  readonly " $data"?: NavHeader_links$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_links">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "href",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideSideNavTitle",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavHeader_links",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "navItems",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NavBarListItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v0/*:: as any*/),
                (v1/*:: as any*/),
                (v2/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "NavBarList",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NavBarLinks",
  "abstractKey": null
};
})();

(node as any).hash = "640ef60b756ae226c7f9bce1b471bd30";

export default node;
